import React from "react";
import HomePage from "../../../HomePage";
import "./index.css";
import loginIllustration from "../../../../Assets/login.png";
import image from "../../../../Assets/signupImage.png";
import icon from "../../../../Assets/icon_white.png";
import choose_lang from "../../../../Assets/choose_lang.png";
import ConsentSteps from "./consentSteps";

interface ISidePanelProps {
  className?: string;
  type: string;
}

const LoginSignupSidePanel: React.FC<ISidePanelProps> = ({
  className,
  type,
}) => {
  return (
    <div className={`${className || ""} typoGraphySection`}>
      {type === "login" ? (
        <HomePage />
      ) : type === "webview" ? (
        <HomePage />
        // <div className="homePageWebview">
        //   <HomePage />
        //   <ConsentSteps />
        // </div>
      ) : (
        <div className="homePageRoot homePageSecondaryBackground">
          {type === "signup" ? (
            <div className="signupBrandPanel">
              <div className="signupBrandTop">
                <img
                  className="signupInkLogo"
                  src={icon}
                  alt="INK Account Aggregator"
                />

                <div className="signupTagline">
                  One Consent. A Smarter You.
                </div>
              </div>

              <div className="signupBrandContent">
                <h1>
                  Start your
                  <br />
                  INK journey
                </h1>

                <p>
                  Create your account to securely
                  <br />
                  share and manage your financial
                  <br />
                  data with trusted institutions.
                </p>
              </div>

               <div className="loginIllustrationWrapper">
                <img
                  src={loginIllustration}
                  className="loginIllustration"
                  alt="Securely manage your financial data with INK-AA"
                />
              </div>

              <div className="signupTrustPoints">
                <div className="signupTrustItem">
                  <div className="trustIcon">✓</div>
                  <span>
                    Your Data
                    <br />
                    Your Control
                  </span>
                </div>

                <div className="signupTrustDivider" />

                <div className="signupTrustItem">
                  <div className="trustIcon">♧</div>
                  <span>
                    Secure
                    <br />
                    & RBI Regulated
                  </span>
                </div>

                <div className="signupTrustDivider" />

                <div className="signupTrustItem">
                  <div className="trustIcon">▤</div>
                  <span>
                    Easy &
                    <br />
                    Transparent
                  </span>
                </div>
              </div>
            </div>
          ) : type === "linkAccount" ? (
            <img className="width40" src={icon} alt="INK" />
          ) : type === "languageSelection" ? (
            <img
              className="width50"
              src={choose_lang}
              alt="Choose Language"
            />
          ) : (
            <></>
          )}
        </div>
      )}
    </div>
  );
};

export default LoginSignupSidePanel;